import { render } from "./LabEquipment.vue?vue&type=template&id=3f9836ee"
import script from "./LabEquipment.vue?vue&type=script&lang=js"
export * from "./LabEquipment.vue?vue&type=script&lang=js"

import "./LabEquipment.vue?vue&type=style&index=0&id=3f9836ee&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__